export const newIntegrations = (integrations) => {
  return { type: 'NEW_INTEGRATIONS', payload: integrations };
};

export const newIntegration = (integration) => {
  return { type: 'NEW_INTEGRATION', payload: integration };
};

export const deleteIntegration = (integration) => {
  return { type: 'DELETE_INTEGRATION', payload: integration };
};

export const updateIntegration = (integration) => {
  return { type: 'UPDATE_INTEGRATION', payload: integration };
};
